import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	emptyFieldText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bespokenDateTimePlaceholderEmptyFieldText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bespokenSingleGroupPickerPlaceholderEmptyFieldText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bespokenMultiGroupPickerPlaceholderEmptyFieldText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bespokenCascadingSelectPlaceholderEmptyFieldText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bespokenSingleSelectPlaceholderEmptyFieldText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bespokenUrlPlaceholderEmptyFieldText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bespokenTextPlaceholderEmptyFieldText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bespokenMultiSelectPlaceholderEmptyFieldText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	emptyFieldText: {
		id: 'issue-empty-field-text.empty-field-text',
		defaultMessage: 'None',
		description: 'Text to indicate that a given issue field has no value set',
	},
	bespokenDateTimePlaceholderEmptyFieldText: {
		id: 'issue-empty-field-text.bespoken-date-time-placeholder-empty-field-text',
		defaultMessage: 'Add date',
		description: 'Text to indicate that date time field has no value set',
	},
	bespokenSingleGroupPickerPlaceholderEmptyFieldText: {
		id: 'issue-empty-field-text.bespoken-single-group-placeholder-empty-field-text',
		defaultMessage: 'Add group',
		description: 'Text to indicate that a single group picker field has no value set',
	},
	bespokenMultiGroupPickerPlaceholderEmptyFieldText: {
		id: 'issue-empty-field-text.bespoken-multi-group-placeholder-empty-field-text',
		defaultMessage: 'Add groups',
		description: 'Text to indicate that a multi group picker field has no value set',
	},
	bespokenCascadingSelectPlaceholderEmptyFieldText: {
		id: 'issue-empty-field-text.bespoken-cascading-select-placeholder-empty-field-text',
		defaultMessage: 'Add option',
		description: 'Text to indicate that cascading select field has no value set',
	},
	bespokenSingleSelectPlaceholderEmptyFieldText: {
		id: 'issue-empty-field-text.bespoken-single-select-placeholder-empty-field-text',
		defaultMessage: 'Add option',
		description: 'Text to indicate that single select field has no value set',
	},
	bespokenUrlPlaceholderEmptyFieldText: {
		id: 'issue-empty-field-text.bespoken-url-placeholder-empty-field-text',
		defaultMessage: 'Add URL',
		description: 'Text to indicate that URL field has no value set',
	},
	bespokenTextPlaceholderEmptyFieldText: {
		id: 'issue-empty-field-text.bespoken-text-placeholder-empty-field-text',
		defaultMessage: 'Add text',
		description: 'Text to indicate that text field has no value set',
	},
	bespokenMultiSelectPlaceholderEmptyFieldText: {
		id: 'issue-empty-field-text.bespoken-multi-select-placeholder-empty-field-text',
		defaultMessage: 'Add options',
		description: 'Text to indicate that multi select field has no value set',
	},
});
export default messages;

export type Message = {
	id: string;
	defaultMessage: string;
	description: string;
};
